import './Loader.css';

interface Props {
  size?: number;
  color?: string;
  bgColor?: string;
  className?: string;
}

function Loader({ size, color, bgColor, className }: Props) {
  return (
    <div
      className={`loader-container fade-in${className ? ` ${className}` : ''}`}
      style={
        {
          '--color': color || 'var(--primary)',
          '--bg_color': bgColor || 'white',
          '--size': size ? `${size}px` : '20px',
        } as React.CSSProperties
      }
    >
      <div className="loader">Loading...</div>
    </div>
  );
}

export default Loader;
